import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Framework from "./pages/Framework";
import Assessment from "./pages/Assessment";
import Results from "./pages/Results";
import MyResults from "./pages/MyResults";
import Employers from "./pages/Employers";
import TeamDashboard from "./pages/TeamDashboard";
import Admin from "./pages/Admin";
import AdminLogin from "./pages/AdminLogin";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/framework" element={<Framework />} />
          <Route path="/assessment" element={<Assessment />} />
          <Route path="/results/:id" element={<Results />} />
          <Route path="/my-results" element={<MyResults />} />
          <Route path="/employers" element={<Employers />} />
          <Route path="/team/:code" element={<TeamDashboard />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/login" element={<AdminLogin />} />
        </Route>
      </Routes>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}
